<template>
  <div>
    <NavBar/>
    <v-main class="third-bg">
      <div id="CertificatesPage" class="container-fluid third-bg py-10">
        <div class="container-md text-center">
          <v-tabs
              v-model="tabs">
            <v-tab
                href="#0">
              مدارک و تحصیلات
            </v-tab>
            <v-tab
                href="#1">
              نمونه مدارک
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item value="0">
              <v-card flat>
                <v-card-text class="p-0">
                  <div class="container-fluid container-md">
                    <div class="row">
                      <div class="col-12">
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="1">
              <v-card flat>
                <v-card-text class="p-0">
                  <div class="container-fluid container-md">
                    <div class="row">
                      <silent-box :gallery="gallery"></silent-box>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </v-main>
    <FooterComponent/>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "Certificates",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {NavBar, FooterComponent},
  data: () => ({
    tabs: null,
    gallery: [
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/aca17933-9002-4d63-bbe8-36786c4582b3.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/daa9858d-b020-474e-8a68-a94c26f8d4de.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/3057c30b-bfe5-4b3b-aec4-6db1ca08846c.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/aca17933-9002-4d63-bbe8-36786c4582b3.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/daa9858d-b020-474e-8a68-a94c26f8d4de.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/3057c30b-bfe5-4b3b-aec4-6db1ca08846c.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/6ee5a6fd-55d8-4cf8-acea-5c084f36a3c6.jpg',
        description: 'گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواه',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/c3f42095-f271-4859-aa17-ade2b4ce1f7a.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/3057c30b-bfe5-4b3b-aec4-6db1ca08846c.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/6ee5a6fd-55d8-4cf8-acea-5c084f36a3c6.jpg',
        description: 'گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ....گواهی ',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
      {
        src: 'https://www.kashanikia.com/wp-content/uploads/2022/06/c3f42095-f271-4859-aa17-ade2b4ce1f7a.jpg',
        description: 'گواهی ....',
        alt: '',
        thumbnailWidth: '220px',
        thumbnailHeight: '220px',
      },
    ]
  })
}
</script>

<style scoped>

</style>
